<template>
<v-card class="grey lighten-4">
  <request-status :request="req" @ok="$emit('saved');window=2" />
  <v-card-title v-if="title" class='overline py-1 grey lighten-4' >
    {{title}}
    <v-spacer />
    <!-- <v-btn @click="get" /> -->
    <v-btn @click="$emit('close')" icon small >
      <v-icon small >mdi-close</v-icon>
    </v-btn>
  </v-card-title>
  <v-divider/>
  <!-- <pre v-text="member" class="caption" /> -->

    <v-window v-model="window" vertical >

      <v-window-item >

        <role-picker return-object
          :with-package="false"
          :business-id="member.seat.business"
          :package="newPackage"
          :roles="newRole"
          @selected="setRole" />

          <!-- <span v-if="newRole && newRole.title" v-text="newRole.title" />
          <span v-if="newPackage && newPackage.title" v-text="newPackage.title" /> -->

      </v-window-item >

      <v-window-item >
        <v-toolbar dense class="my-2" >
          <v-btn icon @click="window=0" >
            <v-icon small class="mr-1">mdi-arrow-left</v-icon>
          </v-btn>
          <v-divider vertical class="mr-2" />
          <v-toolbar-title >Please confirm</v-toolbar-title>
        </v-toolbar>

        <v-row v-if="newRole" >
          <v-col cols="6" >
            <v-card outlined height="100%" class="grey lighten-2 ml-4" >
              <v-card-title class='overline' >
                Current package
              </v-card-title>
              <v-card-text>

                <!-- Package: <strong>{{pkg.title}}</strong><br/> -->
                Role: <strong>{{role.title}}</strong><br/>
                Price: <strong>{{ formatCurrency(pkg.currency, seat.calculated_seat_price) }}</strong>
                <span v-if="seat.custom_price_reason" >
                  ({{seat.custom_price_reason}})
                </span>

              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="6" >
            <v-card elevation="10" class="mr-4">
              <v-card-title class='subtitle-1 overline' >
                New Package
              </v-card-title>
              <v-card-text>
                <!-- Package: <strong>{{newRole.title}}</strong><br/> -->
                Role: <strong>{{newRole.title}}</strong><br/>
                Price: <strong>{{ formatCurrency(pkg.currency, newRole.price) }}</strong>
                <span v-if="newRole.price_reason" >
                  ({{newRole.price_reason}})
                </span>

                <v-alert text tile
                  v-if="priceDifferential !== 0"
                  border="left"
                  type="info" class="my-3 py-1 caption"  >

                  <template v-if="priceDifferential !== 0" >
                    Your pricing will
                    <strong>
                      <template v-if="priceDifferential < 0">increase</template>
                      <template v-else >decrease</template>
                      by {{ formatCurrency(currency, Math.abs(priceDifferential)) }}</strong>
                      on your next billing cycle
                  </template>
                  <template v-else >
                    No change to your monthly subscription
                  </template>

                </v-alert>
              </v-card-text>
              <v-card-actions >
                <v-btn block color="primary" :loading="req.loading" @click="save" >Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-window-item>

      <v-window-item >
        <center>
          <v-card outlined width="400" class="mt-3" >
            <v-card-title class='subtitle-1 justify-center' >
              Account details updated
            </v-card-title>
            <v-card-text v-if="newPackage" >
              <v-icon size="72" color="success" >mdi-check-circle</v-icon><br/>
              Package: {{newPackage.title}}<br/>
              Role: {{newRole.title}}
            </v-card-text>
            <v-card-actions >
              <v-btn block tile @click="$emit('close')" >Done</v-btn>
            </v-card-actions>
          </v-card>
        </center>
      </v-window-item>

    </v-window>

  <!-- <pre v-text="newRole" /> -->
</v-card>
</template>
<script>
import RolePicker from '@/components/pickers/RolePicker.vue'
export default {
  name: 'ChangeRole',
  components: {
    RolePicker
  },
  props: {
    title: { type: String },
    member: { required: true }
  },
  data () {
    return {
      window: 0,
      newRole: null,
      newPackage: null,
      req: {
        resource: 'ag.team',
        extra: 'set_role_package',
        method: 'post'
      }
    }
  },
  watch: {
    memberId: {
      immediate: true,
      handler () {
        if (this.role) { this.newRole = this.role }
        if (this.pkg) { this.newPackage = this.pkg }
      }
    }
  },
  computed: {
    priceDifferential () {
      if (this.seat && this.newRole) {
        return parseFloat(this.seat.calculated_seat_price) - parseFloat(this.newRole.price)
      }
      return 0
    },
    seat () {
      return this.getObjectPath(this.member, 'seat')
    },
    business () {
      return this.getObjectPath(this.member, 'business')
    },
    businessId () {
      let bId = this.getObjectPath(this.seat, 'business')
      if (!bId) {
        bId = this.getObjectPath(this.member, 'business.id')
      }
      return bId
    },
    memberId () {
      return this.getObjectPath(this.member, 'id')
    },
    pkg () {
      return this.getObjectPath(this.member, 'seat.package')
    },
    role () {
      return this.getObjectPath(this.member, 'seat.role')
    },
    payload () {
      return {
        role: this.newRole.id,
        package: this.newPackage.id,
        member: this.memberId
      }
    }
  },
  methods: {
    setRole (role) {
      this.newRole = role
      this.window++
    },
    save () {
      this.req.data = this.payload
      this.$request('save', this.req)
    }
  }
}
</script>
